import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '@/context/AuthContext';
import type { Role } from '@/types';

export interface ProtectedRouteProps {
    role: Role;
}

/**
 * Gate for the two dashboards.
 *
 * A signed-in user holding the *other* role is redirected to their own home
 * rather than to sign-in — bouncing an admin to an ambassador login form would
 * be a dead end, since they have no password here.
 */
export default function ProtectedRoute({ role }: ProtectedRouteProps) {
    const { isLoggedIn, user } = useAuth();
    const location = useLocation();

    if (!isLoggedIn) {
        const target = role === 'admin' ? '/admin/sign-in' : '/sign-in';
        return <Navigate to={target} replace state={{ from: location.pathname }} />;
    }

    if (user?.role !== role) {
        return <Navigate to={user?.role === 'admin' ? '/admin' : '/dashboard'} replace />;
    }

    return <Outlet />;
}
